import { Component, Inject } from "@angular/core";
import { CodePanelValuesModel } from "../../../shared/components/code/codePanelValueModel";
import { CodeValueModelBuilder } from "../../../shared/components/code/providers/codeValueModelBuilder";
import { CodePanel, CodeDisplayStyles, Conf } from "../../../shared/models";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { VisualObjectVisibilityService } from "../../shared";
import { PanelComponent } from "../../shared/panelComponent";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'code-panel',
  templateUrl: './codePanelComponent.html'
})
export class CodePanelComponent extends PanelComponent<CodePanel> {

  public height: string;
  
  public valuesModel: CodePanelValuesModel;

  public isRender = true;

  constructor(public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    public visibilityService: VisualObjectVisibilityService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper,
    public builder: CodeValueModelBuilder) {

    super(confStore, confPageSessionService, visualObjectHelper);

  }

  ngOnInit() {

    this.height = this.visualObjectHelper.panelHeight(this.panel);
    this.width = this.visualObjectHelper.visualObjectWidth(this.panel);
    this.isRender = this.panel.displayStyle === CodeDisplayStyles.Render;

    super.ngOnInit();
  }  

  public listenChanges(): void {

    this.confStore.onConfCodeValuesChange(this.configurationId, this.confSessionId,
      (): void => {
        const uiItem = this.visibilityService.findConfUIItem(this.configuration, +this.id);

        // Get values model which contain the values for each panel belonging to current <ConfUIItem>
        if (uiItem !== null)
          this.valuesModel = this.builder.build(uiItem, true, [CodeDisplayStyles.Render, CodeDisplayStyles.Popup, CodeDisplayStyles.DownloadLink], this.configurationId).get(0);

      }).unsubscribeOn(this.unsubscribeSubject);
  }
}
